module.exports = __webpack_public_path__ + "static/media/addOrderPopup.9c878269.svg";